angular.module('mso.session').controller('SessionExpiryDialogCtrl', ['$scope', '$uibModalInstance', '$timeout', 'SessionExpiryService',
    function ($scope, $uibModalInstance, $timeout, SessionExpiryService) {
        $scope.title = 'Session Expiry';

        var dialogTimeout = $timeout(function() {
            expire();
        }, 30000);

        $scope.confirm = function(){
            $timeout.cancel(dialogTimeout);
            SessionExpiryService.getRefreshToken();
            SessionExpiryService.startInactivityTimer();
            SessionExpiryService.startRefreshTokenTimer();
            $uibModalInstance.close();
        };

        function expire() {
            SessionExpiryService.expireSession();
            $uibModalInstance.close();
        }
    }]);
